import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { EventCodes } from '../../../../core/codes';
import { LoginCommon } from './login.common';
import { PageBaseFull } from '../../../../core/page-base.full';
import { UserData } from '../../../../providers/user-data'; 
import { SignupPage } from '../signup/signup';
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
//import { RecipeData } from '../../../recipes/providers/recipe-data';


@Component({
	selector: 'page-login-full',
	templateUrl: 'login.full.html'
})

export class LoginPageFull extends PageBaseFull{
	public login: {email?: string, password?: string} = {};
	public submitted = false;
	public formMsg: any;
	
	constructor(
    	public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,		
		public common: LoginCommon,
		public nav: NavController,
    	public userData: UserData,
    	public settings: AppSettings,
    	public pageRef: PageRef,
		//public recipeData: RecipeData,
    ) {	
		 super(settings, events, nav, userData);
		 console.log("Loading Account Full");
    }

	ionViewDidEnter() {
		this.app.setTitle('Login');
	}

	ngAfterViewInit() {
		let self = this;
		self.events.subscribe(EventCodes.USER_LOGIN_ERROR, (err)=>{
			self.formMsg = err;
			this.cd.detectChanges();
		});	
	}

	public fbLogin(){
		this.userData.facebookLogin(true,this.nav,  'home');
	}
	
	public googleLogin(){
		this.common.googleLogin();
	}
	
	public onLogin(form){
		 this.common.onLogin(form, this.nav, this.login);
	}

	public openSignUp(){
		this.nav.push(SignupPage);		
	}
	public openForgotPassword(){
		this.nav.setRoot(this.pageRef.get('forgot-password'));
	}
	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/login/login.full.ts